import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {ConnectionUtils} from "@ispm-client/modules/bpmn-modeler/bpmn/utils/connection-utils";
import {select, Store} from "@ngrx/store";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {TreeNavigator} from "@ispm/shared/bpmn-io/services/tree-navigator";
import EventBus from "diagram-js/lib/core/EventBus";
import {FloatingNodesService} from "@ispm/shared/bpmn-io/services/floating-nodes-service";
import {PathwaysModeling} from "@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling";
import {selectNodeCreationInfoById} from "@ispm-client/modules/bpmn-modeler/store/selectors";
import {take} from "rxjs/operators";
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {EventType} from "@ispm/shared/bpmn-io/bpmn-js";
import {Shape} from 'diagram-js/lib/model';

export class AppendConnectionHandler implements CommandHandler {
  private connectionUtils: ConnectionUtils;


  constructor(private elementRegistry, private store$: Store<State>, private treeNavigator: TreeNavigator, private eventBus: EventBus, private floatingNodesService: FloatingNodesService, private pathwaysModeling: PathwaysModeling) {
    this.connectionUtils = new ConnectionUtils(this.elementRegistry);
  }

  postExecute(context) {
    const connection = context.connection;
    const targets = this.getTargetNodes(context.target, connection);
    const originalSource = context.originalSource;

    if (connection) {
      connection.businessObject.neighborhoodID = this.treeNavigator.currentLayer;
      this.connectionUtils.updateSequenceFlowID(connection);
      targets.forEach((targetNode) => {
        this.store$.pipe(select(selectNodeCreationInfoById([targetNode.id])),
          take(1)).subscribe(nodes => {
          if (nodes && nodes[0]) {
            // the source can never change status from float to non-float or vice-versa. Only the target can.
            if (originalSource && this.floatingNodesService.nodeIsNotFloated(originalSource)) {
              this.floatingNodesService.removeFloatedSubTreeFromStoreAfterAppendConnection(targetNode);
            }
            // update connection conditions
            if (nodes && nodes.length > 0) {
              const nodeCreationResult = nodes[0] ? nodes[0].data : undefined;
              const nodeType = ModelingUtil.getNodeType(targetNode);
              const ignoreTrackingChange = true;

              if (nodeCreationResult) {
                this.pathwaysModeling.resetNodeData(targetNode, nodeCreationResult, nodeType, ignoreTrackingChange);
              }
              this.eventBus.fire(EventType.NODE_UPDATED, {
                node: targetNode,
                nodeCreationResult,
                nodeType,
                ignoreTrackingChange
              });
            }
          }
        }).unsubscribe();
      })

    }
  }

  private getTargetNodes(target, connection): Array<Shape> {
    //check if its connection through gateway
    let targets = [];
    if (target) {
      if (target.length) {
        targets = target

      } else {
        targets.push(target);
      }
    } else {
      targets.push(connection.target);
    }
    return targets;

  }
}
